import { useAuth0 } from '@auth0/auth0-react';
import { ROUTE_HOME } from 'routes';
import { Redirect, Route } from 'react-router-dom';
import { Fragment } from 'react';

export default function PrivateRoute(props) {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  if (!isAuthenticated) {
    loginWithRedirect();
  }

  return (
    <Fragment>
      {isAuthenticated ? <Route {...props} /> : <Redirect to={ROUTE_HOME} />}
    </Fragment>
  );
}
